import { domainName, selector, record, lookupFound, recordCreated, lookupBimiFound, lookupBimiDmarcFound } from './stores.js';

// Agari Tools API.
const apiBaseUrl = 'https://api.agari.com/v1/record_lookup';

// DMARC.
// =============================================================================
const apiDmarcLookup = apiBaseUrl + '?record_type=dmarc&domain_name=';
const apiDmarcCreate = apiBaseUrl + '?record_type=dmarc&';

export async function dmarcLookup(domain) {
  let url = apiDmarcLookup + domain;
  const response = await fetch(url);
  const data = await response.json();

  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }

  if (data.record.dmarc != undefined && data.record.dmarc.errors != undefined && data.record.dmarc.errors.length > 0) {
    lookupFound.set(false);
    record.set(data.record);
  }
  else {
    lookupFound.set(true);
    record.set(data.record);
  }

  domainName.update(val => val = domain);

  return record;
}

export async function dmarcCreate(inputRecord) {
  // Marketo API Call.
  // const leadKeys = ['firstName', 'lastName', 'email', 'company'];
  // const lead = {};
  // leadKeys.forEach(key => lead[key] = inputRecord[key]);
  // marketoAddToList(lead);

  // DMARC record creation.
  const options = {
    method: 'POST',
  };
  const recordKeys = ['domain_name', 'p', 'rf', 'adkim', 'aspf', 'pct', 'sp', 'fo', 'ri'];
  const record = {};
  recordKeys.forEach(key => {
    if (inputRecord[key] !== undefined) record[key] = inputRecord[key];
  });

  // Handle 'rua', 'ruf' differently.
  record['rua'] = inputRecord['agari_rua'] + ', ' + inputRecord['rua'];
  record['ruf'] = inputRecord['agari_ruf'] + ', ' + inputRecord['ruf'];

  let query = new URLSearchParams(record);
  let url = apiDmarcCreate + query.toString();

  const response = await fetch(url, options);
  const data = await response.json();

  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }

  if (data.record.dmarc_records != undefined && data.record.errors != undefined && data.record.errors.length > 0) {
    lookupFound.set(false);
    recordCreated.set(data.record);
  }
  else {
    lookupFound.set(true);
    const key = Object.keys(data.record.dmarc_records)[0];
    const dmarcRecords = data.record.dmarc_records[key][0];
    recordCreated.set(dmarcRecords);
  }

  return recordCreated;
}

// DKIM
// =============================================================================
const apiDkimLookup = apiBaseUrl + '?record_type=dkim';

export async function dkimLookup(inputDomain, inputSelector) {
  let url = apiDkimLookup + '&domain_name=' + inputDomain + '&selector=' + inputSelector;
  const response = await fetch(url);
  const data = await response.json();

  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }

  if (data.record.dkim != undefined && data.record.dkim.errors != undefined && data.record.dkim.errors.length > 0) {
    lookupFound.set(false);
    record.set(data.record.dkim);
  }
  else {
    lookupFound.set(true);
    record.set(data.record.dkim);
  }

  domainName.update(val => val = inputDomain);
  selector.update(val => val = inputSelector);

  return record;
}

// SPF
// =============================================================================
const apiSpfLookup = apiBaseUrl + '?record_type=spf';

export async function spfLookup(inputDomain) {
  let url = apiSpfLookup + '&domain_name=' + inputDomain;
  const response = await fetch(url);
  const data = await response.json();

  if (!response.ok) {
    const message = `An error has occured: ${response.status}`;
    throw new Error(message);
  }

  if (data.record.spf != undefined && data.record.spf.errors != undefined && data.record.spf.errors.length > 0) {
    lookupFound.set(false);
    record.set(data.record.spf);
  }
  else {
    lookupFound.set(true);
    record.set(data.record.spf);
  }

  domainName.update(val => val = inputDomain);

  return record;
}

// BIMI
// =============================================================================
const apiBimiLookup = 'http://agari.webenertia.com:9999/txt/default._bimi.';
const apiBimiDmarcLookup = 'http://agari.webenertia.com:9999/txt/_dmarc.';

export async function bimiLookup(inputDomain) {
  let url = apiBimiLookup + inputDomain;
  console.log(url);
  // let response = await fetch(url);
  // let json = await response.json();
  // if (response.ok) {
  // }
  // else {
  //   lookupFound.set(false);

  // }
  // console.log(response);
  // console.log(json);

  if (inputDomain == 'agari.com') {
    lookupBimiFound.set(true);
    lookupBimiDmarcFound.set(true);

    record.set({
      logo: 'https://def0a2r1nm3zw.cloudfront.net/bimi_asset_ae3c98c310790d48676ae50c7d857ab3.svg',
      bimi: {
        "name": "default._bimi.agari.com.",
        "ttl": "300",
        "type": "TXT",
        "value": "v=BIMI1; l=https://def0a2r1nm3zw.cloudfront.net/bimi_asset_ae3c98c310790d48676ae50c7d857ab3.svg"
      },
      dmarc: {
        "name": "_dmarc.02.da.50.02.dns.agari.com.",
        "ttl": "300",
        "type": "TXT",
        "value": "v=DMARC1; p=reject; sp=reject; fo=1; ri=3600; rua=mailto:agari-data@rua.agari.com; ruf=mailto:agari-data@ruf.agari.com"
      }
    });
  }
  else {
    lookupBimiFound.set(false);
    lookupBimiDmarcFound.set(true);

    record.set({});
  }
  domainName.update(val => val = inputDomain);

  return record;
}

// Marketo API.
// =============================================================================
const marketoBaseUrl = 'https://225-DVZ-583.mktorest.com/rest/v1/leads/push.json?access_token=';

export async function marketoAddToList(lead) {

}
